export const SEAT_STATES = {
  UNSELECTED: 0,
  RESERVED: -2,
  SELECTED: -3,
  PAIRED: -4,
  PARING: -5, // ペアリング済だけど選択中
  TEMP_RESERVED: -6,
  RELEASED: -7,
};

export const SEAT_DEFAULT_TYPE = {
  COMMON: 0,
  AISLE: -1,
};

export const MODE = {
  PAIR_RESERVATION: -4,
};
